const links = [
  { label: 'Events', href: '#upcoming' },
  { label: 'Privacy', href: 'https://www.fmc.co.uk/privacy-policy', external: true },
  { label: 'Contact', href: '#partner' },
];

export function SiteFooter() {
  return (
    <footer className="bg-ink py-8">
      <div className="mx-auto flex max-w-content flex-col items-center justify-between gap-4 px-6 md:flex-row md:px-16">
        <span className="font-body text-sm text-white/65">© 2026 FMC / dentistry.co.uk</span>
        <nav aria-label="Footer" className="flex flex-wrap justify-center gap-x-6 gap-y-2">
          {links.map((link) => (
            <a
              key={link.label}
              href={link.href}
              target={link.external ? '_blank' : undefined}
              rel={link.external ? 'noopener noreferrer' : undefined}
              className="font-body text-sm text-white/65 transition-colors hover:text-white"
            >
              {link.label}
            </a>
          ))}
        </nav>
      </div>
    </footer>
  );
}

